import React, { useEffect, useState } from 'react';
import { fabric } from 'fabric';
import { Button, Radio } from 'antd';
import { errorCatch, Field, GET, useAuth, useUserContext, ycStorage, JSXMap } from 'fennec-ui';
import Icofont from 'react-icofont';
import './index.css';
import { SwapOutlined } from '@ant-design/icons';
import Color from '../Color';
import { ycBucket } from '../../../common/Tool';
import { useEventContext } from '../../../common/Context';
import { useLocation, useNavigation } from 'react-router';

var FontFaceObserver = require('fontfaceobserver');

function Editor(props) {
    const { avatarTextKind, template, viewWidth, saveWidth, aspectRatioID, multiplier, admin, event } = props;

    // console.log(event.avatarTemplateMeropriyatie);

    const auth = useAuth();
    const user = useUserContext();

    // x: -400
    // y: 200
    // a: 48

    // x: -300
    // y: 270
    // a: 48

    // x: -200
    // y: 330
    // a: 48

    const textX = -400;//70 * 3;
    const textY = 200;//275 * 3;
    const textFontSize = 50;

    const textX2 = -290;
    const textY2 = 270;
    const textFontSize2 = 50;

    const textX3 = -180;
    const textY3 = 340;
    const textFontSize3 = 50;

    const [object, setObject] = useState({
        visibleLastname: false,
        visibleFirstname: false,
        visibleKind: false,
        lastname: true,
        firstname: true,
        kind: true,

        lastnameColor: "white",
        firstnameColor: "white",
        kindColor: "white",
        firstnameX: textX,
        firstnameY: textY,
        firstnameFontSize: textFontSize,
        lastnameX: textX2,
        lastnameY: textY2,
        lastnameFontSize: textFontSize2,
        kindX: textX3,
        kindY: textY3,
        kindFontSize: textFontSize3,
        lastnameText: user.lastname,
        firstnameText: user.firstname,
        // kindText: 1,
        angle: 0,
        // image: "https://storage.yandexcloud.net/federation-dev/events/51/Москва 26 ноября - Я ИДУ-01.png",
    });

    // const [kindData, setKindData] = useState([
    //     // { ID: 1, name: "Организатор" },
    //     // { ID: 2, name: "Судья" },
    //     // { ID: 3, name: "Я иду!" },
    //     // { ID: 4, name: "Я в теме!" },
    //     // { ID: 5, name: "DJ" },
    // ]);
    const [canvas, setCanvas] = useState();
    const [photo, setPhoto] = useState();
    const [image, setImage] = useState();
    const [kind, setKind] = useState();
    const [lastname, setLastname] = useState();
    const [firstname, setFirstname] = useState();
    const [fontLoad, setFontLoad] = useState(false);
    const [avatarTextSettings, setAvatarTextSettings] = useState();

    const canvasWidth = saveWidth;
    const canvasHeight = canvasWidth * multiplier;

    const preparePhoto = (photo) => {
        photo.centeredScaling = true;
        photo.lockScalingFlip = true
        photo.transparentCorners = false;
        photo.borderColor = 'black'
        photo.cornerColor = 'black'
        photo.cornerStrokeColor = 'black'
        photo.cornerSize = 40
        photo.setControlVisible('ml', false)
        photo.setControlVisible('mb', false)
        photo.setControlVisible('mr', false)
        photo.setControlVisible('mt', false)
        // photo.setControlVisible('mtr', false)
        photo.controls.mtr.offsetY = -25
        photo.controls.mtr.render = function (ctx, left, top, styleOverride, fabricObject) {
            var image = new Image(50, 50), x, y;
            image.src = '/resources/ui-rotation.svg';
            x = left - image.width / 2;
            y = top - image.height / 2;
            ctx.drawImage(image, x, y, 50, 50);

            // styleOverride = styleOverride || {};
            // fabric.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
        }

        photo.on('mouseover', function (e) {
            if (photo.canvas) {
                var canvas = photo.canvas
                canvas.setActiveObject(photo)
                if (canvas.overlayImage) {
                    canvas.overlayImage.set('opacity', 0.65);
                }
                canvas.renderAll();
            }
        });

        photo.on('mouseout', function (e) {
            if (photo.canvas) {
                var canvas = photo.canvas
                if (canvas.overlayImage) {
                    canvas.overlayImage.set('opacity', 1);
                }
                canvas.renderAll();
            }
        });

        photo.on('mousewheel', function (e) {
            if (e && e.e) {
                e.e.preventDefault();
                if (e.e.deltaY < 0) {
                    zoomIn(photo);
                } else if (e.e.deltaY > 0) {
                    zoomOut(photo);
                }
            }
        });

        photo.controls.mtr.mouseUpHandler = function (e, transform) {
            if (transform && transform.target) {
                var angle = transform.target.angle || 0;
                if (angle > 180) {
                    angle -= 360
                }
                setObject(o => ({ ...o, angle: angle }))
            }
        };
    }
    useEffect(() => {
        setObject(o => ({
            ...o,
            lastnameText: user.lastname,
            firstnameText: user.firstname,
        }))
    }, [user]);

    useEffect(() => {
        let canvas = new fabric.Canvas('canvas', {
            height: canvasHeight,
            width: canvasWidth,
            backgroundColor: 'white',
            alignSelf: "center",
        });

        canvas.lowerCanvasEl.style.width = `${viewWidth}px`;
        canvas.lowerCanvasEl.style.height = `${viewWidth * multiplier}px`;
        canvas.upperCanvasEl.style.width = `${viewWidth}px`;
        canvas.upperCanvasEl.style.height = `${viewWidth * multiplier}px`;
        canvas.wrapperEl.style.width = `${viewWidth}px`;
        canvas.wrapperEl.style.height = `${viewWidth * multiplier}px`;

        canvas.allowTaint = true;
        // canvas.foreignObjectRendering = true;
        // canvas.preserveObjectStacking = true;
        setCanvas(canvas);

        var myfont = new FontFaceObserver('UkrainianCompact')
        myfont.load().then(function () {
            setFontLoad(true)
        })
    }, []);

    useEffect(() => {
        if (avatarTextKind) {
            setObject(o => ({
                ...o,
                image: (template) ? ycStorage(auth) + ycBucket(auth) + "/" + template?.ssilka : undefined,
            }));
            if (template) {
                GET(auth, `/api/avatar-text-settings/list/${template?.ID}`,
                    ({ data }) => {
                        setAvatarTextSettings(data);
                        if (data && data.length) {
                            let ofirstname = data?.find(e => e.name === "firstname");
                            let olastname = data?.find(e => e.name === "lastname");
                            let okind = data?.find(e => e.name === "kind");
                            setObject(o => ({
                                ...o,
                                visibleFirstname: (ofirstname) ? ofirstname.visible : o.visibleFirstname,
                                firstnameX: (ofirstname) ? ofirstname.x : o.firstnameX,
                                firstnameY: (ofirstname) ? ofirstname.y : o.firstnameY,
                                firstnameFontSize: (ofirstname) ? ofirstname.fontSize : o.firstnameFontSize,
                                firstnameColor: (ofirstname) ? ofirstname.color : o.firstnameColor,
                                visibleLastname: (olastname) ? olastname.visible : o.visibleLastname,
                                lastnameX: (olastname) ? olastname.x : o.lastnameX,
                                lastnameY: (olastname) ? olastname.y : o.lastnameY,
                                lastnameFontSize: (olastname) ? olastname.fontSize : o.lastnameFontSize,
                                lastnameColor: (olastname) ? olastname.color : o.lastnameColor,
                                visibleKind: (okind) ? okind.visible : o.visibleKind,
                                kindX: (okind) ? okind.x : o.kindX,
                                kindY: (okind) ? okind.y : o.kindY,
                                kindFontSize: (okind) ? okind.fontSize : o.kindFontSize,
                                kindColor: (okind) ? okind.color : o.kindColor,
                            }));
                        }
                    }, errorCatch)
            }
        }
    }, [template, avatarTextKind]);
    useEffect(() => {
        fabric.Image.fromURL(object.photo, function (img) {
            const properties = img.set({
                originX: "center",
                originY: "center",
                left: canvasWidth / 2,
                top: canvasHeight / 2 + 40,
            });
            if (canvasWidth < canvasHeight) {
                properties.scaleToWidth(canvasWidth, false);
            } else {
                properties.scaleToHeight(canvasHeight, false);
            }
            properties.set('selectable', true);
            preparePhoto(img)
            setPhoto(img);
        }, { crossOrigin: 'Anonymous' });
    }, [object.photo]);
    useEffect(() => {
        if (object.image) {
            fabric.Image.fromURL(object.image, function (img) {
                const properties = img.set({
                    left: 0,
                    top: 0
                });
                if (canvasWidth < canvasHeight) {
                    properties.scaleToWidth(canvasWidth, false);
                } else {
                    properties.scaleToHeight(canvasHeight, false);
                }
                properties.set('selectable', false);
                properties.hasBorders = false;
                properties.hasControls = false;
                setImage(img);
            }, { crossOrigin: 'Anonymous' });
        } else {
            setImage(undefined);
        }
    }, [object.image]);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text(object.firstnameText || "", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setFirstname(properties);
    }, []);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text(object.lastnameText || "", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setLastname(properties);
    }, []);
    useEffect(() => {
        let x = textX;
        let y = textY;
        const properties = new fabric.Text("Организатор", { left: x, top: y, fontSize: textFontSize, fontFamily: 'UkrainianCompact', fill: 'white', });
        properties.set('selectable', false);
        properties.hasBorders = false;
        properties.hasControls = false;
        setKind(properties);
    }, []);

    const zoomIn = (photo) => {
        if (!photo.canvas) {
            return
        }

        var scaleVal = 50 / (photo.width || 1);
        photo.scaleY += scaleVal
        photo.scaleX += scaleVal
        photo.canvas.renderAll();
    }
    const zoomOut = (photo) => {
        if (!photo.canvas) {
            return
        }

        var scaleVal = 50 / (photo.width || 1);
        photo.scaleY -= scaleVal
        photo.scaleX -= scaleVal
        photo.canvas.renderAll();
    }
    const flipX = (photo) => {
        if (!photo.canvas) {
            return
        }

        photo.flipX = !photo.flipX
        photo.canvas.renderAll();
    }
    const flipY = (photo) => {
        if (!photo.canvas) {
            return
        }

        photo.flipY = !photo.flipY
        photo.canvas.renderAll();
    }
    useEffect(() => {
        if (canvas && object) {
            canvas.clear();

            if (photo) {
                photo.rotate(object.angle || 0)

                canvas.add(photo).sendToBack(photo);
            }

            if (object.visibleFirstname) {
                firstname.text = object.firstnameText || "";
                firstname.set("fill", object.firstnameColor);
                firstname.set("left", object.firstnameX);
                firstname.set("top", object.firstnameY);
                firstname.set("fontSize", object.firstnameFontSize);
            }
            if (object.visibleLastname) {
                lastname.text = object.lastnameText || "";
                lastname.set("fill", object.lastnameColor);
                lastname.set("left", object.lastnameX);
                lastname.set("top", object.lastnameY);
                lastname.set("fontSize", object.lastnameFontSize);
            }
            if (object.visibleKind) {
                let t = (!avatarTextKind) ? "" : avatarTextKind?.find(e => e.ID === object.kindText)?.name;
                kind.text = (t) ? "" + t : "";

                kind.set("fill", object.kindColor);
                kind.set("left", object.kindX);
                kind.set("top", object.kindY);
                kind.set("fontSize", object.kindFontSize);
            }
            firstname.visible = object.visibleFirstname && object.firstname;
            lastname.visible = object.visibleLastname && object.lastname;
            kind.visible = object.visibleKind && object.kind;

            if (image && firstname && lastname && kind) {
                var group = new fabric.Group([image], {
                    left: 0,
                    top: 0,
                });
                canvas.setOverlayImage(group);
                group.add(firstname)
                group.add(lastname)
                group.add(kind)
            }
        }
    }, [canvas, object, photo, image, firstname, lastname, kind, fontLoad]);

    const load = (url) => {
        const reader = new FileReader();
        reader.onload = function (event) {
            const imgObj = new Image();
            imgObj.src = event.target.result;
            imgObj.onload = function () {
                const image = new fabric.Image(imgObj);
                const properties = image.set({
                    originX: "center",
                    originY: "center",
                    left: canvasWidth / 2,
                    top: canvasHeight / 2 + 40,
                });
                if (canvasWidth < canvasHeight) {
                    properties.scaleToWidth(canvasWidth, false);
                } else {
                    properties.scaleToHeight(canvasHeight, false);
                }
                properties.set('selectable', true);
                preparePhoto(properties);
                setPhoto(properties);
            }
        };
        reader.readAsDataURL(url);
    };
    return (
        <>
            <div style={{ paddingBottom: "25px", backgroundColor: "white" }}>
                <div style={{ display: "flex", alignItems: "flex-start", flexWrap: "wrap" }}>
                    <div style={{ paddingBottom: "10px" }}>
                        <canvas id="canvas" />
                    </div>
                    <div style={{ padding: "0px 15px", flex: "1" }}>
                        <div style={{ width: "100%", paddingBottom: "15px" }}>
                            <Field
                                key={"photo"}
                                auth={auth}
                                item={{
                                    label: "Фото",
                                    name: "file",
                                    type: "file",
                                    showUploadList: false,
                                    accept: ".png,.jpg",
                                }}
                                onChange={files => {
                                    if (files && files.length) {
                                        load(files[0]);
                                    }
                                }}
                            />
                        </div>
                        <div style={{ paddingBottom: "15px", display: "flex", gap: "5px" }}>
                            <Button size="small" onClick={() => zoomIn(photo)}><Icofont icon="ui-zoom-in" /></Button>
                            <Button size="small" onClick={() => zoomOut(photo)}><Icofont icon="ui-zoom-out" /></Button>
                            <Button size="small" onClick={() => flipX(photo)}><SwapOutlined /></Button>
                            <Button size="small" onClick={() => flipY(photo)}><SwapOutlined className="icofont-rotate-90" /></Button>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                                <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                    <div style={{ flex: "0" }}>
                                        <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, angle: 0 }))}>
                                            <Icofont icon="rotation" />
                                        </Button>
                                    </div>
                                    <div style={{ flex: "1" }}>
                                        <Field
                                            key={"angle"}
                                            auth={auth}
                                            item={{
                                                label: 'Поворот',
                                                name: "angle",
                                                type: "int",
                                                filterType: "slider",
                                                realtime: true,
                                                min: -180,
                                                max: 180
                                            }}
                                            value={object.angle}
                                            onChange={v => setObject(o => ({ ...o, angle: v }))}
                                        />
                                    </div>
                                </div>
                            </div>
                            {object.visibleFirstname && <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                                <div style={{ width: "100%", display: "flex", gap: "7px", justifyContent: (admin) ? "flex-start" : "space-between" }}>
                                    <Field
                                        key={"firstname"}
                                        auth={auth}
                                        item={{
                                            label: (!admin) ? object.firstnameText : undefined,
                                            name: "firstname",
                                            type: "bool",
                                        }}
                                        value={object.firstname}
                                        onChange={v => setObject(o => ({ ...o, firstname: v }))}
                                    />
                                    {admin && <Field
                                        key={"firstnameText"}
                                        auth={auth}
                                        item={{
                                            name: "firstnameText",
                                            type: "string",
                                            size: "small"
                                        }}
                                        value={object.firstnameText}
                                        onChange={v => setObject(o => ({ ...o, firstnameText: v }))}
                                    />}
                                    <div style={{ flex: "0" }}>
                                        <Color
                                            disabled={!object.firstname}
                                            value={object.firstnameColor}
                                            onChange={v => {
                                                setObject(o => ({ ...o, firstnameColor: v }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, firstnameX: textX }))}>
                                                X:
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"firstnameX"}
                                                auth={auth}
                                                item={{
                                                    label: 'X',
                                                    name: "firstnameX",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: -1000,
                                            max: 1000,
                                                    view: {
                                                        disabled: !object.firstname,
                                                    }
                                                }}
                                                value={object.firstnameX}
                                                onChange={v => setObject(o => ({ ...o, firstnameX: v }))}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, firstnameY: textY }))}>
                                                Y:
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"firstnameY"}
                                                auth={auth}
                                                item={{
                                                    label: 'Y',
                                                    name: "firstnameY",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: -1000,
                                                    max: 1000,
                                                    view: {
                                                        disabled: !object.firstname,
                                                    }
                                                }}
                                                value={object.firstnameY}
                                                onChange={v => setObject(o => ({ ...o, firstnameY: v }))}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, firstnameFontSize: textFontSize }))}>
                                                <Icofont icon="font" />
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"firstnameFontSize"}
                                                auth={auth}
                                                item={{
                                                    label: 'Y',
                                                    name: "firstnameFontSize",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: 22 * 2,
                                                    max: 22 * 6,
                                                    view: {
                                                        disabled: !object.firstname,
                                                    }
                                                }}
                                                value={object.firstnameFontSize}
                                                onChange={v => setObject(o => ({ ...o, firstnameFontSize: v }))}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {object.visibleLastname && <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                                <div style={{ width: "100%", display: "flex", gap: "7px", justifyContent: (admin) ? "flex-start" : "space-between" }}>
                                    <Field
                                        key={"lastname"}
                                        auth={auth}
                                        item={{
                                            label: (!admin) ? object.lastnameText : undefined,
                                            name: "lastname",
                                            type: "bool",
                                        }}
                                        value={object.lastname}
                                        onChange={v => setObject(o => ({ ...o, lastname: v }))}
                                    />
                                    {admin && <Field
                                        key={"lastnameText"}
                                        auth={auth}
                                        item={{
                                            name: "lastnameText",
                                            type: "string",
                                            size: "small"
                                        }}
                                        value={object.lastnameText}
                                        onChange={v => setObject(o => ({ ...o, lastnameText: v }))}
                                    />}
                                    <div style={{ flex: "0" }}>
                                        <Color
                                            disabled={!object.lastname}
                                            value={object.lastnameColor}
                                            onChange={v => {
                                                setObject(o => ({ ...o, lastnameColor: v }));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, lastnameX: textX2 }))}>
                                                X:
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"lastnameX"}
                                                auth={auth}
                                                item={{
                                                    label: 'X',
                                                    name: "lastnameX",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: -1000,
                                            max: 1000,
                                                    view: {
                                                        disabled: !object.lastname,
                                                    }
                                                }}
                                                value={object.lastnameX}
                                                onChange={v => setObject(o => ({ ...o, lastnameX: v }))}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, lastnameY: textY2 }))}>
                                                Y:
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"lastnameY"}
                                                auth={auth}
                                                item={{
                                                    label: 'Y',
                                                    name: "lastnameY",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: -1000,
                                            max: 1000,
                                                    view: {
                                                        disabled: !object.lastname,
                                                    }
                                                }}
                                                value={object.lastnameY}
                                                onChange={v => setObject(o => ({ ...o, lastnameY: v }))}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, lastnameFontSize: textFontSize2 }))}>
                                                <Icofont icon="font" />
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"lastnameFontSize"}
                                                auth={auth}
                                                item={{
                                                    label: 'Y',
                                                    name: "lastnameFontSize",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: 22 * 2,
                                                    max: 22 * 6,
                                                    view: {
                                                        disabled: !object.lastname,
                                                    }
                                                }}
                                                value={object.lastnameFontSize}
                                                onChange={v => setObject(o => ({ ...o, lastnameFontSize: v }))}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {object.visibleKind && <div style={{ width: "100%", padding: "5px 10px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px" }}>
                                <div style={{ width: "100%", display: "flex", gap: "7px" }}>
                                    <Field
                                        key={"kind"}
                                        auth={auth}
                                        item={{
                                            // label: 'Организатор',
                                            name: "kind",
                                            type: "bool",
                                        }}
                                        value={object.kind}
                                        onChange={v => setObject(o => ({ ...o, kind: v }))}
                                    />
                                    <Field
                                        key={"kindText"}
                                        auth={auth}
                                        item={{
                                            // label: 'Организатор',
                                            name: "kindText",
                                            type: "object",
                                            view: {
                                                disabled: !object.kind,
                                            },
                                            relation: {
                                                display: (item) => {
                                                    return item.name
                                                },
                                                reference: {
                                                    data: avatarTextKind,
                                                }
                                            },
                                            size: "small"
                                        }}
                                        value={object.kindText}
                                        onChange={v => setObject(o => ({ ...o, kindText: v }))}
                                    />
                                    <div style={{ flex: "0" }}>
                                        <Color
                                            value={object.kindColor}
                                            onChange={v => setObject(o => ({ ...o, kindColor: v }))}
                                        />
                                    </div>
                                </div>
                                <div style={{ width: "100%" }}>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, kindX: textX3 }))}>
                                                X:
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"kindX"}
                                                auth={auth}
                                                item={{
                                                    label: 'X',
                                                    name: "kindX",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: -1000,
                                                    max: 1000,
                                                    view: {
                                                        disabled: !object.kind,
                                                    }
                                                }}
                                                value={object.kindX}
                                                onChange={v => setObject(o => ({ ...o, kindX: v }))}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, kindY: textY3 }))}>
                                                Y:
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"kindY"}
                                                auth={auth}
                                                item={{
                                                    label: 'Y',
                                                    name: "kindY",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: -1000,
                                                    max: 1000,
                                                    view: {
                                                        disabled: !object.kind,
                                                    }
                                                }}
                                                value={object.kindY}
                                                onChange={v => setObject(o => ({ ...o, kindY: v }))}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
                                        <div style={{ flex: "0" }}>
                                            <Button type="text" size='small' style={{ padding: "0px" }} onClick={v => setObject(o => ({ ...o, kindFontSize: textFontSize3 }))}>
                                                <Icofont icon="font" />
                                            </Button>
                                        </div>
                                        <div style={{ flex: "1" }}>
                                            <Field
                                                key={"kindFontSize"}
                                                auth={auth}
                                                item={{
                                                    label: 'Y',
                                                    name: "kindFontSize",
                                                    type: "int",
                                                    filterType: "slider",
                                                    realtime: true,
                                                    min: 22 * 2,
                                                    max: 22 * 6,
                                                    view: {
                                                        disabled: !object.kind,
                                                    }
                                                }}
                                                value={object.kindFontSize}
                                                onChange={v => setObject(o => ({ ...o, kindFontSize: v }))}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            <div style={{ width: "100%", paddingTop: "15px" }}>
                                <Button type='primary' style={{ width: "100%" }} onClick={e => {
                                    let b64 = canvas.toDataURL({
                                        format: 'png',
                                        left: 0,
                                        top: 0,
                                        width: canvasWidth,
                                        height: canvasHeight
                                    });

                                    var a = document.createElement("a");
                                    document.body.appendChild(a);
                                    a.style = "display: none";
                                    a.href = b64;
                                    a.download = "";
                                    a.click();
                                    window.URL.revokeObjectURL(b64);
                                }}>Скачать</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default function AvatarEditor(props) {
    const { admin, event } = props;
    const auth = useAuth();
    const user = useUserContext();
    const [avatarTextKind, setAvatarTextKind] = useState([]);

    // Аватарки
    // 2269x2269 | 1:1  | 1:1  
    // 2269x4033 | 9:16 | 1.7777 : 0.5626
    // 1591x531  | 3:1  | 2,996233522 : 0,333752357
    const aspectRatioArray = [
        { ID: 1, key: "1:1", label: "Квадрат", multiplier: 1 / 1, divider: 1 / 1 },
        { ID: 2, key: "9:16", label: "INSTAGRAM", multiplier: 16 / 9, divider: 9 / 16 },
        { ID: 3, key: "3:1", label: "VK", multiplier: 1 / 3, divider: 3 / 1 },
        { ID: 4, key: "3:4", label: "3:4", multiplier: 4 / 3, divider: 3 / 4 },
    ]
    const [aspectRatio, setAspectRatio] = useState(aspectRatioArray[0]);
    const getAvatarTemplateByAspectRatio = (avatarTemplates, aspectRatio) => {
        return avatarTemplates?.find(e => (e.aspectRatio === aspectRatio.ID) || (!e.aspectRatio && aspectRatio.ID === 1));
    }
    const [template, setTemplate] = useState();

    useEffect(() => {
        if (event && event.avatarTemplateMeropriyatie && event.avatarTemplateMeropriyatie.length) {
            let avatarTemplate = getAvatarTemplateByAspectRatio(event.avatarTemplateMeropriyatie, aspectRatio);
            setTemplate(avatarTemplate)
        }
    }, [event, aspectRatio]);
    useEffect(() => {
        if (template) {
            GET(auth, `/api/avatar-text/list/${template?.ID}`,
                ({ data }) => {
                    setAvatarTextKind(data);
                }, errorCatch)
        }
    }, [template])
    return (
        <div style={{ paddingBottom: "25px", backgroundColor: "white" }}>
            {event &&
                <div style={{ display: "flex", justifyContent: "space-between", gap: "15px", alignItems: "center" }}>
                    <div style={{ fontWeight: "600", padding: "10px 0", fontSize: "20px", flex: "1" }}>
                        {event.nazvanieMeropriyatiya}
                    </div>
                </div>
            }
            <div style={{ width: "100%", padding: "5px 0px", marginBottom: "5px", backgroundColor: "rgb(250 250 250)", borderRadius: "4px", display: "flex", justifyContent: "space-between" }}>
                <Radio.Group value={aspectRatio?.ID} onChange={(e) => setAspectRatio(aspectRatioArray.find(c => c?.ID == parseInt(e.target.value)))}>
                    {JSXMap(aspectRatioArray, (e, idx) => {
                        if(getAvatarTemplateByAspectRatio(event.avatarTemplateMeropriyatie, e)){
                            return (<Radio.Button key={idx} value={e.ID} >{e.key}</Radio.Button>)
                        }
                    })}
                </Radio.Group>
            </div>
            {aspectRatio && <Editor admin={admin} event={event} key={aspectRatio?.ID} template={template} avatarTextKind={avatarTextKind} viewWidth={(aspectRatio.ID != 3) ? 400 : 920} saveWidth={(aspectRatio.ID != 3) ? 1200 : 2000} aspectRatioID={aspectRatio?.ID} multiplier={aspectRatio?.multiplier} />}
        </div>
    );
}
